import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M7.4816 10.5199C5.78297 8.82128 5.39942 7.12266 5.3129 6.44211C5.28872 6.25393 5.35348 6.06522 5.4881 5.93154L6.86272 4.55755C7.06492 4.35547 7.10081 4.04054 6.94924 3.79815L4.7606 0.399688C4.59292 0.131288 4.24862 0.0344192 3.96559 0.176009L0.452035 1.83075C0.223155 1.94345 0.0885309 2.18663 0.114518 2.44042C0.298618 4.18936 1.0611 8.48867 5.2862 12.714C9.51131 16.9394 13.81 17.7016 15.5599 17.8857C15.8137 17.9117 16.0569 17.777 16.1696 17.5482L17.8244 14.0346C17.9654 13.7522 17.8692 13.4089 17.6019 13.2409L14.2034 11.0529C13.9612 10.9011 13.6462 10.9368 13.444 11.1388L12.07 12.5134C11.9363 12.648 11.7476 12.7127 11.5594 12.6886C10.8789 12.602 9.18023 12.2185 7.4816 10.5199Z"
        fill={props.strokeColor ?? "black"}
        fill-opacity="0.8"
      />
    </Svg>
  );
}

export default SvgComponent;
